import React from "react";

export function ForgotPasswordForm({ 
  t, 
  email, 
  setEmail, 
  loading, 
  setLoading, 
  onForgotPassword, 
  onCancel, 
  addToast 
}) {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onForgotPassword(email);
    } catch (err) {
      addToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
        {t.resetPassword}
      </h3>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 20 }}>
        {t.resetDesc}
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">{t.email}</label>
          <div className="form-input-wrap">
            <span className="form-input-icon">✉</span>
            <input
              className="form-input"
              type="email"
              placeholder={t.emailPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>
        </div>
        <div className="form-actions">
          <button
            className="btn-primary"
            type="submit"
            disabled={loading}
            style={{ flex: 1 }}
          >
            {loading ? "…" : t.sendResetLink}
          </button>
          <button className="btn-cancel" type="button" onClick={onCancel}>
            {t.cancel}
          </button>
        </div>
      </form>
    </>
  );
}